import { Component, OnInit,Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../../core/api.service';
import { FunctionsService } from '../../core/global/functions.service';
import { UtilityService } from '../../core/global/utility.service';
import { ChangeDetectorRef } from '@angular/core';
@Component({
  selector: 'app-upload-csv-modal',
  templateUrl: './upload-csv-modal.component.html',
  styleUrls: ['./upload-csv-modal.component.sass']
})
export class UploadCsvModalComponent {
  @Input() endPoint:string
  fileType: any = '';
  isloaded = 0;
  file = [];
  selectedFileName: string;
  is_save:boolean=false
  constructor(public activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private _adminService: ApiService, private _functions: FunctionsService, private _utility: UtilityService, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {

  }
  selectFile(event, fileType: any) {
    if (fileType == 'csv') {
      this.is_save=false
      this.fileType = 1;
      this.file = event.target.files;
      this.selectedFileName = event.target.files[0] ? event.target.files[0].name : '';

      // Trigger change detection manually
      this.cdr.detectChanges();
    } else {
      this.fileType = 2;
    }
  }
  uploadFile(filetype: any) {
    this.is_save=true
    if (this.file.length > 0) {
      this._utility.showLoader()
      this.isloaded = 1;
      const fd = new FormData();
      // let url = 'users/qr-user-upload'
      fd.append('filetype', filetype);
      fd.append('csv', this.file[0]);
      this._adminService.photoUpload(this.endPoint, fd).subscribe((res) => {
        this._utility.hideLoader()
        if (res.success == true) {
          this.isloaded = 0;
          this._utility.toastSuccess(res.message);
          this.activeModal.close(true);
        } else {
          this._utility.toastWarning(res.message);
        }
      });
    }
    else {
      this._utility.toastWarning('Select File');
    }
  }
  save() {
    this.uploadFile('csv');
  }
}
